import { render } from "./EditPetSexMore.vue?vue&type=template&id=4c88ff5a&scoped=true"
import script from "./EditPetSexMore.vue?vue&type=script&lang=js"
export * from "./EditPetSexMore.vue?vue&type=script&lang=js"

import "./EditPetSexMore.vue?vue&type=style&index=0&id=4c88ff5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c88ff5a"]])

export default __exports__